var   KEYS  = require('../../keys/Keys');
var   AXIOS = require('axios');

export {DeleteProductAsync as InvokeAsync , DeleteProductSync as InvokeSync}

async function DeleteProductAsync(LoginToken,ProductUUID,BootUUID)
{
    var DeleteProductPromise = new Promise((resolve, reject) => {
        DeleteProductSync(LoginToken,ProductUUID,BootUUID,(response,error) => {
            if (error) {  
                try{ 
                    return reject(error.response.data.message);
                }catch(ex){
                    return reject('Unknown error');
                }
            }
            if(response.status==='fails'){
                reject(response.error);
            }else{
                resolve(null);
            }
        });
    });

    return await DeleteProductPromise;
}

function DeleteProductSync(LoginToken,ProductUUID,BootUUID,Callback)
{
    AXIOS({
        headers:{
            'Content-Type': 'application/json',
            'x-api-key'   : KEYS.AWS_XKEY,
        },
        method : 'post',
        url    :'/Admin/DeleteProduct',                
        data  : {
            AppID       :KEYS.AWS_APPID,
            ProductUUID :ProductUUID   ,
            BootUUID    :BootUUID      ,
            LoginToken  :LoginToken    ,
            DeleteAll   :'true'                      
        },                                
    })
    .then((response)=>{
        Callback(response.data,null);
    },(error) => { 
        Callback(null,error + ' ');
    });
}
